import styled from 'styled-components';

export const StyledWrapper = styled.div`
  svg {
    width: 100%;
    height: auto;
  }
`;
